import React from "react";

import classes from "./styles.module.scss";

import { VoltaBlueSmallLogo } from "~assets/images/icons/JSX/VoltaSmallBlueLogo";

const PresetAmount = ({ amount, isAmountSelected, onClick }) => {
    return (
        <div
            className={`${classes.presetAmountContainer} ${isAmountSelected ? classes.presetAmountSelected : ""}`}
            onClick={onClick}
        >
            <span className={classes.presetAmountText}>{amount}</span>
            <VoltaBlueSmallLogo fill={isAmountSelected ? "#0049C6" : "#222222"} />
        </div>
    );
};

export default PresetAmount;
